// extracted by mini-css-extract-plugin
export default {"simpleHeader":"SimpeHeader_simpleHeader__mNulJ","simpleHeader__logo":"SimpeHeader_simpleHeader__logo__QvwKB"};